export const KeyCode = {
  Backspace: 8,
  Space: 32,
  ArrowDown: 40,
  ArrowUp: 38,
  Enter: 13,
};
